import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { CourseModel } from '../course/course.model';
import { TopicModel } from '../topic/topic.model';

export class SubjectModel extends BaseModel {
  name: string = undefined;
}


export class SubjectModelWithCourses extends SubjectModel {
  @JsonProperty({ clazz: CourseModel })
  courses: CourseModel[] = [];
}

export class SubjectModelWithTopics extends SubjectModel {
  @JsonProperty({ clazz: CourseModel })
  topics: TopicModel[] = [];
}
